export class Base {
  constructor (vueComponent) {
    this._vueComponent = vueComponent
    this._emitter = vueComponent.$emitter

    this._operationMap = {}
  }

  async processOperation (operation, data) {
    let cb = this._operationMap[data.class][operation]

    await cb.call(this, data)
  }

  async _requestForm (name, data, editable = true, event = null) {
    event = event || name

    this._emitter.emit('updateForm', name, {
      defaults: data,
      event,
      editable
    })
  }

  async alertSuccess (text, title = 'Success') {
    this._vueComponent.$notify({
      group: 'alert',
      type: 'success',
      title,
      text
    })
  }

  async alertError (text, title = 'Error') {
    this._vueComponent.$notify({
      group: 'alert',
      type: 'error',
      title,
      text
    })
  }

  async alertStrictError (text, title = 'Error') {
    this._vueComponent.$notify({
      group: 'alert',
      type: 'error',
      title,
      text,
      duration: 10000
    })
  }

  _addListener (event, cb) {
    this._emitter.removeAllListeners(event)

    this._emitter.on(event, async data => {
      let respEvent = `${event}Resp`
      let respData

      try {
        respData = await cb(data)

        if (this.afterSubmitHook) {
          this.afterSubmitHook()
        }

        this._emitter.emit(respEvent, null, respData)
      } catch (err) {
        this._emitter.emit(respEvent, err, respData)
      }
    })
  }

  _addFormListener (event, cb) {
    this._addListener(event, async data => {
      try {
        await cb(data)
      } catch (err) {
        this.alertStrictError(err.message)
        throw err
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/home/controllers/base.js